import * as React from 'react'
import styled from 'styled-components'

import { StoryblokComponentProps } from '../../types/StoryblokComponentProps'
import { StoryblokBase } from '../../types/StoryblokBase'

interface UnderOverlineTextProps extends StoryblokBase {
  text: string;
  size?: number;
}

export const UnderOverlineStyle = styled.span<{ size?: number }>`
  font-family: ${({ theme }) => theme.font.highlight.family};
  font-weight: ${({ theme }) => theme.font.highlight.weight.regular};
  font-size: ${({ size }) => size ? size + "rem" : "1.25rem"};
  padding-top: -4px;
  padding-left: 8px;
  padding-right: 8px;

  svg {
    fill: ${({ theme }) => theme.colors.fonts.body};
  }
`

const UnderOverlineText = (props: StoryblokComponentProps<UnderOverlineTextProps>) => {
  const { blok } = props;
  return (
    <UnderOverlineStyle size={blok.size}>{blok.text}</UnderOverlineStyle>
  )
}

export default UnderOverlineText
